<template>
<div>
<div v-title>快贷</div>
<div class="content">
	<!-- 轮播banner图 -->
	<!-- <div class="swiper-container">
	    <div class="swiper-wrapper">
	        <div class="swiper-slide swiper-banner" :style="bannerStyle"></div>
	    </div>
	    <div class="swiper-pagination"></div>
	</div> -->
	<!-- 头部 -->
	<div class="header-box">
		<div class="homepage-header">
			<div class="header-logo l">
				<i class="main-logo"></i>
			</div>
			<div class="r">
				<ul class="header-text l">
					<router-link tag="li" :to="{path: '/homepage'}">
						<a href="#">首页</a>
					</router-link>
					<li><a href="#" @click="openLayer">产品服务</a></li>
					<router-link tag="li" :to="{path: '/antiFraud'}">
						<a href="#">反欺诈</a>
					</router-link>
					<router-link tag="li" :to="{path: '/assetsPricing'}">
						<a href="#">资产定价</a>
					</router-link>
					<li @click="openLayer"><a href="#">坏账揽收</a></li>
					<li @click="openLayer"><a href="#">资金供给</a></li>
				</ul>
				<p class="header-button l" style="margin-right:40px;">
					<span @click="openLayer"><a href="#">申请接入</a></span>
					<span @click="login"><a href="#">商家登录</a></span>
				</p>
			</div>
		</div>
	</div>

	<swiper :options="swiperOption">
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle">
				<div class="dyfqz-container">
					<p class="dyfqz-title">智能CRM</p>
					<div class="dyfqz-desc">
						<p>基于客户情报与销售士兵的作战优劣势而生</p>
						<p>商业智能CRM为信贷企业提供“借贷情报、供需撮合、风险决策”的全流程服务</p>
					</div>
				</div>
			</div>
		</swiper-slide>
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle2">
				<div class="dyfqz-container">
					<p class="dyfqz-title">重新定义反欺诈</p>
					<div class="dyfqz-desc">
						<p>竞品征信平台对指标的定义不同，</p>
						<p>造成数据存在大量的重复、矛盾、漏掉及重复性接入成本投入。</p>
					</div>
					<div class="dyfqz-desc">
						<p>快贷云致力于数据整合，除提供贷前欺诈、多头借贷、征信、司法、公安劣迹查杀外，</p>
						<p>更大的价值在于贷后每日的动态扫描、监听及风险预警，让您全程透视风险</p>
					</div>
				</div>
				<div class="dyfqz-item dyfqz-circles"></div>
				<div class="dyfqz-item dyfqz-lines"></div>
			</div>
		</swiper-slide>
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle3">
				<div class="dyfqz-container">
					<p class="dyfqz-title">资金供应</p>
					<div class="dyfqz-desc">
						<p>缺钱、拆借、危机、有时候不是你的团队差</p>
						<p>而是你的竞争力差，因为你缺强劲的低息资金授信支持</p>
					</div>
					<div class="dyfqz-desc">
						<p>在这里，只要你的团队认真做事，钱的问题不是问题！</p>
					</div>
				</div>
			</div>
		</swiper-slide>
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle4">
				<div class="dyfqz-container">
					<p class="dyfqz-title">坏账揽收</p>
					<div class="dyfqz-desc">
						<p>咱们吃的就是风险这碗饭！</p>
						<p>不是每家都能妥善消化风险、处置资产！</p>
					</div>
					<div class="dyfqz-desc">
						<p>您无法处理的，可以交给专业团队、边际成本更低！</p>
					</div>
				</div>
			</div>
		</swiper-slide>
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle5">
				<div class="dyfqz-container">
					<p class="dyfqz-title">财务业务一体化</p>
					<div class="dyfqz-desc">
						<p>互联网时代，每个行业都有软件、每家公司都有几套系统</p>
						<p>您痛苦的打通、打通、打通，在这里办公财务业务一体化</p>
					</div>
					<div class="dyfqz-desc">
						<p>您无法处理的，可以交给专业团队、边际成本更低！</p>
					</div>
				</div>
			</div>
		</swiper-slide>
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle6">
				<div class="dyfqz-container">
					<p class="dyfqz-title">All in one</p>
					<div class="dyfqz-desc">
						<p>引流、获客、情报、反欺诈、风险定价、下户尽调、公证上抵、GPS监控</p>
						<p>贷后风险预警、还款代扣、催收揽收、坏账揽收All-in-One解决方案</p>
					</div>
				</div>
			</div>
		</swiper-slide>
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle7">
				<div class="dyfqz-container">
					<p class="dyfqz-title">SaaS模式</p>
					<div class="dyfqz-desc">
						<p>信贷管理从未如此简单</p>
						<p>隔离的信息、复杂的流程、多变的市场，在SaaS面前，就是即开即用</p>
					</div>
				</div>
			</div>
		</swiper-slide>
		<swiper-slide>
			<div class="swiper-banner dyfqz-banner" :style="bannerStyle8">
				<div class="dyfqz-container">
					<p class="dyfqz-title">风险定价</p>
					<div class="dyfqz-desc">
						<p>价格是否客观足以公认？速度是否秒出足以给力？这是个问题...</p>
						<p>放贷后，资产价值的缩水风险能否第一时间感知，更是一个问题！</p>
					</div>
					<div class="dyfqz-desc">
						<p>今天，快贷云联合车300、世联、首佳为您提供深度“风险定价+”服务！</p>
					</div>
				</div>
			</div>
		</swiper-slide>
		<div class="swiper-pagination" slot="pagination"></div>
	</swiper>
	

	<!-- 主体内容 -->
	<div class="section">
		<!-- 主体内容一 能做什么 -->
		<div class="section-first">
			<p class="section-title pt86 pb25">我们能为你做什么</p>
			<p class="section-word">我们不只是提供一套系统，更要为您提供更多救火服务。资金供给，欺诈拦截、多头侦测、资产定价、风控决策、协作审批、</p>
			<p class="section-word pb80">业务撮合、贷中管理、贷后管理、回款代扣、尽调承揽、催收托管、外勤管理、台账管理等，业务一体化掌控，全面赋能信贷机构，让信贷更专业、更智能！</p>
			<div class="section-product">
				<dl class="product-tab">
					<dt><img src="./images/sqicon_zjgj.png"></dt>
					<dd>资金供给</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_qzlj.png"></dt>
					<dd>欺诈拦截</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_dtjd.png"></dt>
					<dd>多头借贷侦测</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_zcdj.png"></dt>
					<dd>资产定价</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_fkjc.png"></dt>
					<dd>风控决策</dd>
				</dl>
			</div>
			<div class="section-product">
				<dl class="product-tab">
					<dt><img src="./images/sqicon_gpszz.png"></dt>
					<dd>GPS追踪</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_bywx.png"></dt>
					<dd>保养维修追踪</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_dzlc.png"></dt>
					<dd>定制化流程</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_dhyj.png"></dt>
					<dd>贷后风险预警</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_hkdk.png"></dt>
					<dd>还款代扣</dd>
				</dl>
			</div>
			<div class="section-product">
				<dl class="product-tab">
					<dt><img src="./images/sqicon_khgl.png"></dt>
					<dd>客户管理</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_txzq.png"></dt>
					<dd>弹性展期</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_xjgl.png"></dt>
					<dd>续借管理</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_dagl.png"></dt>
					<dd>档案管理</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_ypgl.png"></dt>
					<dd>押品管理</dd>
				</dl>
			</div>
			<div class="section-product">
				<dl class="product-tab">
					<dt><img src="./images/sqicon_jdwt.png"></dt>
					<dd>尽调委托</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_gzdy.png"></dt>
					<dd>代办公证抵押</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_cswt.png"></dt>
					<dd>催收委托</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_dybx.png"></dt>
					<dd>抵押物变现</dd>
				</dl>
				<dl class="product-tab">
					<dt><img src="./images/sqicon_sswt.png"></dt>
					<dd>诉讼委托</dd>
				</dl>
			</div>
		</div>
		
		<!-- 主体内容二 解决什么 -->
		<div class="section-second">
			<p class="section-title-fff pt86 pb20">我们能为你解决什么</p>
			<p class="section-word-fff pb56">你所关心的，我们都已考虑。你未想到的，这里早已帮你想全</p>
			<div class="second-content second-part-animate">
				<div class="part-one-box animate-box"  @mouseover.prevent="animateOne($event,0)">
					<p class="part-one"></p>
					<span class="part-one-text">让销售业绩全面提升</span>
				</div>
				<div class="part-two-box animate-box"  @mouseover.prevent="animateOne($event,1)">
					<p class="part-two"></p>
					<span class="part-two-text">让更角色协作化繁为简</span>
			 	</div>
				<div class="part-three-box animate-box"  @mouseover.prevent="animateOne($event,2)">
					<p class="part-three"></p>
					<span class="part-three-text">让批贷不再拍脑袋</span>
			 	</div>
				<div class="part-four-box animate-box"  @mouseover.prevent="animateOne($event,3)">
					<p class="part-four"></p>
					<span class="part-four-text">让贷后风险不再后知后觉</span>
			 	</div>
			</div>

			<div class="learn-more" @click="openLayer">了解更多</div>
		</div>
		
		<!-- 主体内容三 模式 -->
		<div class="section-third">
			<p class="section-title pt86 pb20">我们的模式 · 全而开放的生态</p>
			<p class="section-word pb56">迟来的快贷信贷云-专注服务全球信贷、助贷、等非银金融机构</p>
			<div class="sq-pattern">
				<dl class="sq-pattern-tab">
					<dt>
						<span><img src="./images/sq_pattern_tab1.png"></span>
					</dt>
					<dd>
						<h3 class="pattern-title">移动</h3>
						<p>传统业务，需对接多方系统</p>
						<p>信息隔离较繁琐。快贷云支持APP，电脑端</p>
						<p>移动化，省去下线繁琐步骤</p>
					</dd>
				</dl>
				<dl class="sq-pattern-tab">
					<dt>
						<span><img src="./images/sq_pattern_tab2.png"></span>
					</dt>
					<dd>
						<h3 class="pattern-title">协同</h3>
						<p>流程可配，弹性扩展</p>
						<p>帮助各角色决策</p>
						<p>贷前贷后透视·分销·流量·残值</p>
					</dd>
				</dl>
				<dl class="sq-pattern-tab">
					<dt>
						<span><img src="./images/sq_pattern_tab3.png"></span>
					</dt>
					<dd>
						<h3 class="pattern-title">助贷</h3>
						<p>向资方提供可控的伙伴</p>
						<p>向助贷机构提供低息资金</p>
						<p>为您提供稳定、成本低、手续简的金融通道</p>
					</dd>
				</dl>
			</div>
		</div>

		<!-- 主体内容四 服务保障 -->
		<div class="section-fourth">
			<p class="section-title-fff pt86 pb20">我们的服务保障</p>
			<p class="section-word-fff pb86">你所关心的，我们都已考虑。你未想到的，这里早已帮你想全</p>
			<div class="safety-box">
				<ul>
					<li class="safety-box-li active" @mouseover="animateTwo(0)">
						<p class="safety-1-1"></p>
						<p class="safety-1-2"></p>
					</li>
					<li class="safety-box-li" @mouseover="animateTwo(1)">
						<p class="safety-2-1"></p>
						<p class="safety-2-2"></p>
					</li>
					<li class="safety-box-li" @mouseover="animateTwo(2)">
						<p class="safety-3-1"></p>
						<p class="safety-3-2"></p>
					</li>
					<li class="safety-box-li" @mouseover="animateTwo(3)">
						<p class="safety-4-1"></p>
						<p class="safety-4-2"></p>
					</li>
				</ul>
			</div>
			<p class="c94deff pt28">{{safetyText}}</p>
		</div>
		
		<!-- 主体内容五 -->
		<div class="section-fifth">
			<p class="section-title pt86 pb25">我们的伙伴</p>
			<p class="section-word">迟来的快贷信贷云-专注服务全球信贷、助贷、等非银金融机构</p>
			<p class="section-word pb66">加入快贷信贷云生态合作伙伴计划，开创新业务，获取资金、风控、技术、资源，实现更快速成长</p>
			<ul class="partner-icon">
				<li class="mb70">
					<span class="pattern_ygbx">
						<img src="./images/pattern_ygbx.png">
						<img src="./images/pattern_ygbx_1.png">
					</span>
					<span class="pattern_cabx">
						<img src="./images/pattern_cabx.png">
						<img src="./images/pattern_cabx_1.png">
					</span>
					<span class="pattern_bdjr">
						<img src="./images/pattern_bdjr.png">
						<img src="./images/pattern_bdjr_1.png">
					</span>
					<span class="pattern_yqjr">
						<img src="./images/pattern_yqjr.png">
						<img src="./images/pattern_yqjr_1.png">
					</span>
					<span class="pattern_zgpa">
						<img src="./images/pattern_zgpa.png">
						<img src="./images/pattern_zgpa_1.png">
					</span>
					<span class="pattern_zxcy">
						<img src="./images/pattern_zxcy.png">
						<img src="./images/pattern_zxcy_1.png">
					</span>
				</li>
				<li class="mb53">
					<span class="pattern_aliy">
						<img src="./images/pattern_aliy.png">
						<img src="./images/pattern_aliy_1.png">
					</span>
					<span class="pattern_r360">
						<img src="./images/pattern_r360.png">
						<img src="./images/pattern_r360_1.png">
					</span>
					<span class="pattern_sqjr">
						<img src="./images/pattern_sqjr.png">
						<img src="./images/pattern_sqjr_1.png">
					</span>
					<span class="pattern_tdkj">
						<img src="./images/pattern_tdkj.png">
						<img src="./images/pattern_tdkj_1.png">
					</span>
					<span class="pattern_vgj">
						<img src="./images/pattern_vgj.png">
						<img src="./images/pattern_vgj_1.png">
					</span>
					<span class="pattern_c300">
						<img src="./images/pattern_c300.png">
						<img src="./images/pattern_c300_1.png">
					</span>
				</li>
				<!-- <li>
					<span class="pattern_baidu">
						<img src="./images/pattern_baidu.png">
						<img src="./images/pattern_baidu_1.png">
					</span>
				</li> -->
			</ul>
		</div>

	</div>
	
<div class="suspend-wrap">
    <ul>
	    <li>
	        <a class="suspend-btn-1" rel="nofollow" href="javascript:void(0)" @click="meiQiaShowPanel()">
	        	<!-- <p>
	        		<span @click="meiQiaShowPanel('ab01105f18bbdba1a1c3f1a3f9cd3099')">投诉<br >举报</span>
	        		<span @click="meiQiaShowPanel('c5356f9fded6122d07d2551abfe500b0')">商务<br >合作</span>
	        		<span @click="meiQiaShowPanel('7294371bd5613de5dbc17474d36b1a96')">总部<br >财务</span>
	        		<span @click="meiQiaShowPanel('6151e1c6a26f089b5182f027c524c3f6')">总部<br >风控</span>
	        		<span @click="meiQiaShowPanel('95b91aa44418c9a068de30015416e701')">总部<br >技术</span>
	        	</p> -->
	        </a>
	    </li>
	    <!-- <li>
	        <a class="suspend-btn-2" href="#"></a>
	    </li> -->
	    <li>
	        <a class="suspend-btn-3" href="javascript:;"><span></span></a>
	    </li>
	    <li id="backTop" @click="goTop" v-show="isShow">
	        <a class="suspend-btn-4" href="javascript:;"></a>
	    </li>
    </ul>
</div>

<footerIndex></footerIndex>

</div>
</div>
</template>

<script type="text/ecmascript-6">
	import footerIndex from '../common/footerIndex.vue'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	export default{
		data(){
			return {
				isShow:false,
				swiperOption: {
					loop: true,
					autoplay:true,
					pagination: {
						el: '.swiper-pagination',
						clickable :true,
					}
				},
				bannerStyle:{
		            background: "url(" + require("./images/banner.jpg") + ") center no-repeat",
		            backgroundSize: "auto 100%",
				},
				bannerStyle2: {
					background: 'linear-gradient(-45deg,#28a7ff,#345eff)',
				},
				bannerStyle3: {
					background: "url(" + require("./images/banner3.jpg") + ") center no-repeat",
		            backgroundSize: "cover",
				},
				bannerStyle4: {
					background: "url(" + require("./images/banner4.jpg") + ") center no-repeat #491ae2",
		            backgroundSize: "auto 100%",
				},
				bannerStyle5: {
					background: "url(" + require("./images/banner5.jpg") + ") center no-repeat #24252a",
		            backgroundSize: "auto 100%",
				},
				bannerStyle6: {
					background: "url(" + require("./images/banner6.jpg") + ") center no-repeat",
		            backgroundSize: "cover",
				},
				bannerStyle7: {
					background: "url(" + require("./images/banner7.jpg") + ") center no-repeat",
		            backgroundSize: "cover",
				},
				bannerStyle8: {
					background: "url(" + require("./images/banner8.jpg") + ") center no-repeat",
		            backgroundSize: "cover",
				},
				safetyText:'数据存储有阿里云护航，VeriSign加密，数据权限锁定到人',
				textArr:['数据存储有阿里云护航，VeriSign加密，数据权限锁定到人','融360、百度大数据等互联网金融大数据信源，欺诈一网打尽','借款人数据全程加密，脱敏处理，保证隐私安全','车300、首佳、世联专业定价，交易畅通：4家代扣、3家充值通道'],

			}
		},
		components: {
			footerIndex,
			swiper,
			swiperSlide
		},
		methods:{
			animateOne,
			animateTwo,
			openLayer,
			login,
			goTop,
			meiQiaShowPanel

		},
		mounted(){
			let _this = this;
			window.addEventListener('scroll',function(){
            	var height = document.documentElement.offsetHeight || document.body.offsetHeight;
            	var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > 100){
                	_this.isShow = true;
                }else{
                	_this.isShow = false;
                }			
			});
			/*美洽代码*/
			(function(m, ei, q, i, a, j, s) {
			    m[a] = m[a] || function() {
			        (m[a].a = m[a].a || []).push(arguments)
			    };
			    j = ei.createElement(q),
			        s = ei.getElementsByTagName(q)[0];
			    j.async = true;
			    j.charset = 'UTF-8';
			    j.src = i + '?v=' + new Date().getUTCDate();
			    s.parentNode.insertBefore(j, s);
			})(window, document, 'script', '//eco-api.meiqia.com/dist/meiqia.js', '_MEIQIA');
			_MEIQIA('entId', 95078);
			_MEIQIA('withoutBtn', true);
		}
	}

	function meiQiaShowPanel(ID){
        _MEIQIA('allSet', function(){
          _MEIQIA('showPanel'); 
        });
        _MEIQIA('init');
        /*_MEIQIA('showPanel', {
            groupToken:ID
        });*/
	}

	function goTop(){
		//document.documentElement.scrollTop = document.body.scrollTop = 0;
        var gotoTop= function(){
			var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
				currentPosition -= 10;
			if(currentPosition > 0){
				window.scrollTo(0, currentPosition);
			}else{
				window.scrollTo(0, 0);
				clearInterval(timer);
				timer = null;
			}
        }
        var timer=setInterval(gotoTop,1);
	}

	function login(){
		// location.href = 'http://admin.test.senqiang.cn';
		location.href = this.$store.state.adminUrl;
	}

	function animateOne(e,num){
		var animateArr = document.getElementsByClassName("animate-box");
		for(var i = 0; i<animateArr.length;i++){
			if( i == num){
				animateArr[i].classList.add("active");
			}else{
				animateArr[i].classList.remove("active");
			}
		}
	}

	function animateTwo(num){
		var animateArr = document.getElementsByClassName("safety-box-li");
		for(var i = 0; i<animateArr.length;i++){
			if( i == num){
				animateArr[i].classList.add("active");
				this.safetyText = this.textArr[i];
			}else{
				animateArr[i].classList.remove("active");
			}
		}
	}

	function openLayer(){
		this.$message({
			showClose: true,
			message: '正在努力开发中,敬请期待',
			type: 'success',
			duration: 1000
		});
	}


</script>
<style>
	@import '../../css/homepage.css'
</style>


// WEBPACK FOOTER //
// src/components/homepageComponent/homepage.vue